import React from 'react';
import { Table } from 'semantic-ui-react';
import { connect } from 'react-redux';
import fields from '@/constants/fields';
import UnsortedColumn from '@/components/table/UnsortedColumn';
import RowAddColumn from '@/components/table/RowAddColumn';
import { addLookupItem } from '../../dictionaries/actions';
import LookupOptionWarningCell from '../components/LookupOptionWarningCell';

const VocabularyTableColumns = ({
  canEdit,
  showEmptyRow,
  errors,
  validationWarnings,
  lookupName,
  showWarning,
}) => {
  const nameError = errors.find((e) => (
    e.context.lookupName === lookupName && e.fields.includes(fields.NAME)));

  const uriError = errors.find((e) => (
    e.context.lookupName === lookupName && e.fields.includes(fields.URI)));

  const warning = validationWarnings.find((e) => (
    e.context.lookupName === lookupName && !e.context.lookupItemUUID && e.fields.includes(fields.NAME)));

  return (
    <Table.Row>
      {showWarning && (<LookupOptionWarningCell warning={warning} />)}
      <UnsortedColumn colWidth={4} columnId="name" error={nameError} />
      <UnsortedColumn colWidth={7} columnId="description" />
      <UnsortedColumn colWidth={5} columnId="uri" error={uriError} />
      {canEdit && (<RowAddColumn entity="lookup" onClick={() => showEmptyRow()} />)}
    </Table.Row>
  );
};

const mapDispatchToProps = {
  showEmptyRow: addLookupItem,
};

export default connect(null, mapDispatchToProps)(VocabularyTableColumns);
